import type { Feature } from '@luna/gatekeeper';

export const cardLockAndReplace: Feature = {
    enabled: false,
    _description: 'Enables display of the refactored card lock and replace focus page',
};
